import { Router, NavigationEnd, ActivatedRouteSnapshot } from "@angular/router";
import { Component, OnDestroy } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Chart } from "chart.js";
import { SubSink } from "subsink";

import { GoogleAnalyticsService } from "@/core/services";
import {
  ConfigurationService,
  AuthenticationService,
} from "@/shared-module/services";
import { Configuration } from "@/shared-module/models";
import { Userpilot } from "userpilot";

// https://medium.com/@PurpleGreenLemon/how-to-properly-add-google-analytics-tracking-to-your-angular-web-app-bc7750713c9e
declare let gtag;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnDestroy {
  dynamicFlag = false;
  rowNumbering = true;
  subs = new SubSink();

  // tslint:disable:max-line-length

  constructor(
    public router: Router,
    private titleService: Title,
    private googleService: GoogleAnalyticsService,
    private configurationService: ConfigurationService,
    private authenticationService: AuthenticationService,
  ) {
    Chart.defaults.global.plugins.datalabels.display = false;
    Userpilot.initialize("NX-83afb615");
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const title = this.extractTitle(this.router.routerState.snapshot.root);
        this.titleService.setTitle(title ? `${title} | MegaLearning` : "MegaLearning");
        this.googleService.record(
          "navigation",
          "navigate",
          "navigate to " + event.urlAfterRedirects,
        );
        gtag("config", "xx-xxxxx-xx", {
          page_path: event.urlAfterRedirects,
        });
        Userpilot.reload();
      }
    });

    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser) {
      this.subs.sink = this.configurationService.config.subscribe(
        (c: Configuration) => {
          this.dynamicFlag = c.highContrast;
          this.rowNumbering = c.useRowNumbering;
        },
      );
    }
  }

  private extractTitle(node: ActivatedRouteSnapshot): string | undefined {
    let current: ActivatedRouteSnapshot | null = node;
    let last: string | undefined;
    while (current) {
      if (current.data?.["title"]) last = current.data["title"];
      current = current.firstChild;
    }
    return last;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
